export const APPLICANT_SUMMARY = 'applicant-summary';
export const CREDIT_REPORT = 'credit-report';
export const BACKGROUND_CHECK = 'background-check';
export const INCOME_DOCUMENT = 'income-document';
export const COMBINED_APPLICATION = 'rental-application';

// now implemented in rentals-js pdf-renderer
export const DEPRECATED_PROPERTY_SHEET = 'property-sheet';

export default [APPLICANT_SUMMARY, CREDIT_REPORT, BACKGROUND_CHECK, INCOME_DOCUMENT, COMBINED_APPLICATION];
